import * as z from 'zod';
import { PAYMENT_TYPE, PRICING_MODEL } from 'src/features/servicePlanPricingPolicies/utils/types';

export type ServicePlanPricingPolicyFormSchemaValues = z.infer<typeof servicePlanPricingPolicyFormSchema>;
export const servicePlanPricingPolicyFormSchema = z.object({
    valid_from: z.string(),
    payment_type: z.enum(PAYMENT_TYPE),
    amount: z.number().int().min(0),
    valid_to: z.string().optional().nullable(),
    tax_reason: z.string(),
    pricing_model: z.enum(PRICING_MODEL),
});

export type PatchServicePlanPricingPolicyFormSchemaValues = z.infer<typeof patchServicePlanPricingPolicyFormSchema>;
export const patchServicePlanPricingPolicyFormSchema = servicePlanPricingPolicyFormSchema.partial();
